import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SunMark = ({ className = "w-5 h-5" }) => (
  <svg viewBox="0 0 64 44" fill="none" className={className} aria-hidden="true">
    <g stroke="currentColor" strokeWidth="4.5" strokeLinecap="round">
      <line x1="6" y1="34" x2="1" y2="34" />
      <line x1="14.5" y1="16.5" x2="10.9" y2="12.9" />
      <line x1="32" y1="9" x2="32" y2="3" />
      <line x1="49.5" y1="16.5" x2="53.1" y2="12.9" />
      <line x1="58" y1="34" x2="63" y2="34" />
      <line x1="9.5" y1="25" x2="4.2" y2="22.5" />
      <line x1="54.5" y1="25" x2="59.8" y2="22.5" />
    </g>
    <path
      d="M14 40 a18 18 0 0 1 36 0 Z"
      fill="currentColor"
      stroke="none"
    />
  </svg>
);

export const WaveLine = ({ className = "", stroke = "currentColor" }) => (
  <svg viewBox="0 0 220 24" fill="none" className={className} aria-hidden="true">
    <path
      d="M2 14 C 22 2, 44 2, 62 14 C 80 26, 102 26, 120 14 C 138 2, 160 2, 178 14 C 190 22, 204 22, 218 14"
      stroke={stroke}
      strokeWidth="5"
      strokeLinecap="round"
    />
  </svg>
);
